/**
 * Renders a player banner with their information
 */
import React from "react";
import ProfileImageContainer from "../core/ProfileImageContainer";
import { Link } from "react-router-dom";

const PlayerBanner = ({
  id,
  forename,
  surname,
  club_id,
  club_logo,
  col1,
  col2,
  institution,
  mainteam,
  joined,
  status,
  number,
  nationality,
  regType,
}) => {
  const gradientStyle = {
    background: `linear-gradient(to right, ${col1}, ${col2})`,
  };



  return (
    // Dynamic gradient bar from col1 to col2
    <div className="w-full homegradient " style={gradientStyle}>
      <div className="flex flex-row justify-between items-center border-1 border-white rounded-lg">
        <div className="flex flex-col w-full justify-between items-left border-1 border-blue">
          <div className="flex flex-row w-full max-md:justify-center max-md:items-center md:justify-between md:items-left border-1 border-black">
            {/* Player image and info, left */}
            <div className="bannerLPlayer flex flex-row justify-start items-start py-3">
              {/* Container for player image and club logo in bottom left */}
              <div className="relative md:h-44 md:w-44 h-40 w-32 xs:w-40">
                <ProfileImageContainer
                    player={id}
                    alt={`${forename} ${surname}`}
                    club={club_id}
                    backup={club_logo}
                    extraClasses="rounded"
                />

                {/* Club image at the bottom-left corner breaking out */}
                <Link to={`/club/${club_id}`}>
                <img
                  src={`https://buiha.org.uk/assets/img/icon/md/${club_logo}.png`}
                  alt={mainteam}
                  className="absolute bottom-[-10px] left-[-12px] xs:h-12 xs:w-12 h-10 w-10"
                />
            </Link>
              </div>

              {/* Player info - name, institution, main team, joined, status */}
              <div className="flex flex-col justify-center xs:justify-between ml-2 xxs:ml-4 items-between max-md:h-40 h-full max-xs:py-1">
                {/* Forename */}
                <div className="flex flex-col items-start max-xs:mb-4">
                  <h1 className="xs:text-xl text-sm font-semibold leading-tight mb-0.5 xs:/mb-1 text-light-1">
                    {forename}
                  </h1>
                  <div className="flex flex-col items-start">
                    <div className="flex items-center">
                      {/* Surname */}
                      <h1
                        className={`pb-0 font-semibold leading-none mb-0 text-light-1 ${
                          surname.length > 9
                            ? "text-xl xs:text-2xl xs:text-3xl"
                            : "text-3xl xs:text-4xl"
                        }`}
                        style={{ lineHeight: "0.8" }}
                      >
                        {surname.toUpperCase()}
                      </h1>
                      {/* Nationality Flag */}
                      {nationality.map((nat) => {
                        let src = `https://buiha.org.uk/assets/img/nationalities/${nat}.png`;
                        let alt = `${nat} Flag`;
                        return (
                          <img src={src} alt={alt} className="hidden xxs:flex w-6 h-6 ml-2" />
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Player info - Institution, Main Team, Joined, Status */}
                <div className="flex flex-col justify-left items-left">
                  <div className="flex flex-row justify-left items-center mb-1 xxs:mb-0.5">
                    {/* Institution */}
                    <img
                      src="/assets/uni.webp"
                      alt="Institution"
                      style={{ filter: "brightness(0) invert(1)" }}
                      className="w-4 h-4 xs:w-5 xs:h-6 xs:ml-0.5 mr-1.5 xs:mr-2.5"
                    />
                    {/* Calc Registration Type */}
                    {regType === "2" ? (
                      <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs">
                        {institution + " (Staff)"}
                      </p>
                    ) : regType === "3" ? (
                      <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs">
                        {institution + " (Alumni)"}
                      </p>
                    ) : regType === "4" ? (
                      <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs">
                        {institution + " (Challenge Only)"}
                      </p>
                    ) : (
                      <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs">
                        {institution}
                      </p>
                    )}
                  </div>

                  {/* Main Team */}
                  <div className="flex flex-row justify-left items-centre mb-1 xxs:mb-0.5">
                    <img
                      src="/assets/people.webp"
                      alt="Main Team"
                      style={{ filter: "brightness(0) invert(1)" }}
                      className="w-4 h-4 mr-1.5 xs:w-6 xs:h-6 xs:mr-2"
                    />
                    <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs ">
                      {mainteam}
                    </p>
                  </div>

                  {/* Joined */}
                  <div className="flex flex-row justify-left items-centre mb-1 xxs:mb-0.5">
                    <img
                      src="/assets/clock.webp"
                      alt="Joined"
                      style={{ filter: "brightness(0) invert(1)" }}
                      className="w-4 h-4 mr-1.5 xs:w-6 xs:h-6 xs:mr-2"
                    />
                    <p className="xs:text-xl leading-tight text-xxs text-light-1 xxs:text-xs ">
                      {"Joined " + joined + " (" + status + ")"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Player number, right */}
            <div className="bannerRPlayer select-none flex flex-col justify-end items-end">
              <p
                className="hidden pb-1 font-roboto font-semibold leading-none m-0 md:block"
                style={{
                  fontSize: "11.5rem",
                  WebkitTextStroke: "5px white",
                  textStroke: "5px white",
                  color: "transparent",
                }}
              >
                {number}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerBanner;
